<template>
    <figure
        :class="[
            'flex items-center justify-center bg-white rounded-full shadow-md shrink-0',
            sizeClasses,
        ]"
    >
        <activix-avatar
            class="object-cover w-full h-full text-gray-700 bg-gray-200 border border-gray-200 rounded-full"
            :username="username"
            :src="src"
            :size="avatarSize"
        />
    </figure>
</template>

<script setup lang="ts">
    import { computed } from 'vue';

    interface Props {
        username: string;
        src?: string;
        size?: 'sm' | 'lg';
    }

    const props = withDefaults(defineProps<Props>(), {
        src: '',
        size: 'sm',
    });

    const sizeClasses = computed<string>(() => (props.size === 'lg' ? 'w-12 h-12' : 'w-10 h-10'));
    const avatarSize = computed<number>(() => (props.size === 'lg' ? 38 : 30));
</script>
